<script setup lang="ts">
import mainVideo from "@/assets/videos/Error/404.mp4";
import bgImg from "@/assets/img/error/404.png";
const { animationEnabled } = useCustom();
const redirectToHome = () => {
  clearError({
    redirect: "/",
  });
};
</script>
<template>
  <div class="section">
    <div class="main">
      <CommonVideoWithPlaceholder
        :video-src="mainVideo"
        :is-playing="animationEnabled"
        :placeholder="bgImg"
        :class-video="'main-video'"
        :class-placeholder="'main-video'"
        :alt="$t('alt.tvError404')"
      />
    </div>
    <div>
      <button class="cursor-hover" @click="redirectToHome">
        {{ $t("404.button") }}
      </button>
    </div>
    <p class="paragraph light-text">
      <span class="highlight">{{ $t("404.text.part-1") }}</span>
      {{ $t("404.text.part-2") }}
    </p>
  </div>
</template>
<style scoped>
.main {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.section {
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

button {
  z-index: 99;
  position: relative;
  border: none;
  background-color: var(--vt-c-purple);
  color: var(--vt-c-white);
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: max-content;
  width: 264px;
  height: 72px;
  box-sizing: border-box;
}
button:hover {
  background-color: #441cd0;
  box-shadow: 0 0 90px 0 #441cd0;
}
.paragraph {
  width: 50%;
  max-width: 657px;
  margin-top: 2rem;
  text-align: center;
}
::v-deep(.main-video) {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  position: relative;
}

@media screen and (max-width: 780px) {
  .paragraph {
    width: 80%;
  }
  button {
    width: 224.33px;
    height: 49.563px;
    min-height: 49.563px;
    font-size: 17px;
  }
  ::v-deep(.main-video) {
    max-width: 80%;
    height: auto;
    object-fit: contain;
  }
}
@media screen and (max-height: 600px) {
  button {
    width: 224.33px;
    height: 49.563px;
    min-height: 49.563px;
    font-size: 17px;
  }
  .paragraph {
    font-size: 17px;
    line-height: 23px;
  }
}
</style>
